module.exports = __webpack_public_path__ + "img/map-citationX.8225166f.gif";